import React, { useState, useEffect } from "react";
import Api from "../util/api";
import Util from "../util/util";
import Settings from "../config/settings";
import swal from 'sweetalert2';
import useLoading from "../hooks/useLoading";
import { Turnstile } from '@marsidev/react-turnstile'
import { useRef } from 'react'

function FormLogin(props) {
  const turnstileRef = useRef(null);
  const {startLoading, stopLoading } = useLoading();
  const [state, setState] = useState({
    auth: {
      email: "",
      pass: "",
      captchaToken: "",
    },
    error: null,
    loading: false,
  });
  const handleChange = (e) => {
    const { id, value } = e.target;
    setState((prevState) => ({
      ...prevState,
      auth: {
        ...prevState.auth,
        [id]: value,
      },
    }));
  };

  useEffect(()=>{
    validateToken();
  },[]);

  const loginClick = async (e) => {
    e.preventDefault();
    try {
      startLoading();
      var res = await Api.auth.login(
          {
            ...state.auth,
            captchaToken: turnstileRef.current?.getResponse()
          }
      );
      var data = await res.json();
      console.log(data);
      if (await Util.requestSuccess(res)) {
        localStorage.setItem("JWT", data.token);
        localStorage.setItem("user", JSON.stringify(data.user));
        window.location.href = "/app/documentos/";
      } else {
        stopLoading();
        await swal.fire("¡Ups!", data.msg, "error");
      }
    } catch (e) {
      console.log(e);
      stopLoading();
      await swal.fire("¡Ups!", "Error al iniciar sesión. Es posible que tengas problemas con tu conexión a internet.", "error");
    }
    turnstileRef.current?.reset();
  };

  const validateToken = async (e) => {
    var jwt = localStorage.getItem("JWT");
    if(jwt){
      var res = await Api.auth.tokenValido();
      if (await Util.requestSuccess(res)) {
        window.location.href = "/app/documentos/";
      }
    }
  }
  
  return (
    <form
      className="cozy"
      action=""
      data-validate-on="submit"
      autoComplete="off"
      noValidate
    >
      <label className="control-label bold small text-uppercase color-2">
        Usuario / correo
      </label>
      <div className="form-group has-icon">
        <input
          type="text"
          id="email"
          name="Login[username]"
          className="form-control form-control-rounded"
          placeholder="Escribe tu correo "
          onChange={handleChange}
          required
        />
        <i className="icon fas fa-user"></i>
      </div>
      <label className="control-label bold small text-uppercase color-2">
        Contraseña
      </label>
      <div className="form-group has-icon">
        <input
          type="password"
          id="pass"
          name="Login[password]"
          className="form-control form-control-rounded"
          placeholder="Tu contraseña"
          onChange={handleChange}
          required
        />
        <i className="icon fas fa-lock"></i>
      </div>
      <Turnstile
          ref={turnstileRef}
          siteKey={Settings.turnstile_key}
      />
      <div className="form-group d-flex align-items-center justify-content-between">
        <a href="/forgot" className="text-warning small">
          ¿Olvidaste tu contraseña?
        </a>
        <div className="ajax-button">
          <div className="fas fa-check btn-status text-success success"></div>
          <div className="fas fa-times btn-status text-danger failed"></div>
          <button
            id="cmdLogin"
            className="btn btn-accent btn-rounded"
            onClick={loginClick}
          >
            Inicio
            <i className="fas fa-long-arrow-alt-right ml-2"></i>
          </button>
        </div>
      </div>
      
    </form>
  );
}

export default FormLogin;
